import React, { forwardRef } from "react";
import { flip, offset, size, useFloating } from "@floating-ui/react-dom";
import { Portal } from "react-portal";
import { Box } from "@chakra-ui/react";
export function usePopover() {
    const { x, y, reference, floating, strategy, update } = useFloating({
        placement: "bottom-start",
        middleware: [
            flip(),
            offset(8),
            size({
                apply({ rects, availableHeight, elements }) {
                    elements.floating.style.width = `${rects.reference.width}px`;
                    elements.floating.style.maxHeight = `${Math.min(320, availableHeight)}px`;
                },
            }),
        ],
    });
    return {
        update,
        getTargetProps(props) {
            return {
                ref: reference,
                ...props,
            };
        },
        getPopoverProps() {
            return {
                ref: floating,
                left: `${x ?? 0}px`,
                top: `${y ?? 0}px`,
                position: strategy,
            };
        },
    };
}
export const Popover = forwardRef(({ isOpen, children, ...props }, ref) => {
    return (React.createElement(Portal, null,
        React.createElement(Box, { ref: ref, background: "white", border: "1px", borderColor: "gray.400", borderRadius: "md", boxShadow: "lg", outline: "none", display: "flex", flexDirection: "column", overflow: "auto", overscrollBehavior: "contain", transition: isOpen
                ? "opacity 150ms linear, transform 150ms cubic-bezier(0.34, 1.56, 0.64, 1)"
                : undefined, transform: "auto", transformOrigin: "top", translateY: isOpen ? 0 : -6, opacity: isOpen ? 1 : 0, pointerEvents: isOpen ? "auto" : "none", minWidth: "3xs", zIndex: "popover", ...props }, children)));
});
